export const ExplanationBanner = ({ fill = '#001965' }: { fill?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
            d="M6.24863 2.49695H4.16443C3.24357 2.49695 2.49707 3.24345 2.49707 4.16431V6.24851"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M2.49707 13.7516V15.8358C2.49707 16.7566 3.24357 17.5031 4.16443 17.5031H6.24863"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M13.752 17.5031H15.8362C16.757 17.5031 17.5035 16.7566 17.5035 15.8358V13.7516"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M17.5035 6.24851V4.16431C17.5035 3.24345 16.757 2.49695 15.8362 2.49695H13.752"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.87485 6.66533C9.75974 6.66533 9.66643 6.75864 9.66643 6.87375C9.66643 6.98886 9.75974 7.08217 9.87485 7.08217C9.98996 7.08217 10.0833 6.98886 10.0833 6.87375C10.0833 6.75864 9.98996 6.66533 9.87485 6.66533V6.66533"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.17383 9.37476H10.1326V12.9179"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M9.16699 12.9179H11.092"
            stroke={fill}
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
